import apiServices from "../../../../../services/apiServices";
import eventBus from "../../../../main";
//import router from "../../../../src/router/index"
//import jwtDecode from "jwt-decode";

export default {
  state: {
    userAvatar: {
      photo: ""
    }
  },
  mutations: {
    SET_AVATAR(state, value) {
      state.userAvatar.photo = value.name;
    }
  },
  actions: {
    userAvatars(context, avatar) {
      eventBus.$emit("openSpin", true); // emit the event to the bus
      apiServices
        .getAvatar(avatar)
        .then(function(response) {
          if (response.status === 200) {
            let obj = response.data;
            if (obj.code === 200 && obj.type === "success") {
              context.commit("SET_AVATAR", obj);
              let payload = {
                color: "success",
                text: "Fotografia de perfil carregada com sucesso",
                errorLogin: true
              };
              eventBus.$emit("openInfo", payload); // emit the event to the bus
            } else {
              let payload = {
                color: "error",
                text: "Ups! Pedido não processado",
                errorLogin: true
              };
              eventBus.$emit("openInfo", payload); // emit the event to the bus
            }
          } else {
            let payload = {
              color: "error",
              text: "Ups! Detectamos alguma incongruência",
              errorLogin: true
            };
            eventBus.$emit("openInfo", payload); // emit the event to the bus
          }
        })
        .catch(function() {

          let payload = {
            color: "error",
            text: "Ups! seu pedido não foi processado",
            errorLogin: true
          };
          eventBus.$emit("openInfo", payload); // emit the event to the bus
        })
        .finally(function() {
          eventBus.$emit("openSpin", false); // emit the event to the bus
        });
    },

    userProfileUpdate(context, profile) {
      eventBus.$emit("openSpin", true); // emit the event to the bus
      apiServices
        .updateProfile(profile)
        .then(function(response) {
          if (response.status === 200) {
            let obj = response.data;
            if (obj.code === 200 && obj.type === "success") {
              context.commit("SET_AVATAR", obj);
              let payload = {
                color: "success",
                text: "Dados actualizados com sucesso!",
                errorLogin: true
              };
              eventBus.$emit("openInfo", payload); // emit the event to the bus
            } else {
              let payload = {
                color: "error",
                text: "Ups! Pedido não processado",
                errorLogin: true
              };
              eventBus.$emit("openInfo", payload); // emit the event to the bus
            }
          } else {
            let payload = {
              color: "error",
              text: "Ups! Detectamos alguma incongruência",
              errorLogin: true
            };
            eventBus.$emit("openInfo", payload); // emit the event to the bus
          }
        })
        .catch(function() {

          let payload = {
            color: "error",
            text: "Ups! seu pedido não foi processado",
            errorLogin: true
          };
          eventBus.$emit("openInfo", payload); // emit the event to the bus
        })
        .finally(function() {
          eventBus.$emit("openSpin", false); // emit the event to the bus
        });
    }
  }
};
